import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRole } from '../models/index';
import { Store } from '@ngrx/store';
import { D4CActions, GeneralState, Selectors } from '../store';
import { RouterModule } from '@angular/router';
import { LanguagePrefixPipe } from '@ca/ca-ng-core';

@Component({
  selector: 'ca-footer',
  imports: [CommonModule, RouterModule, LanguagePrefixPipe],
  template: `
    <div id="footer">
      @if (data$ | async; as data) {
        <nav id="footer-nav">
          @for (navItem of data.navItems; track $index) {
            <div class="footer-nav-list">
              <h3>
                <a [routerLink]="[] | languagePrefix | async" (click)="setRole(navItem.filter)">{{
                  navItem.name
                }}</a>
              </h3>
              @for (menuGroup of data.mainMenuGroups; track $index) {
                @if (menuGroup[navItem.filter]) {
                  <h4>{{ menuGroup.title }}</h4>
                  <ul>
                    @for (link of menuGroup.items; track $index) {
                      @if (link[navItem.filter]) {
                        <li>
                          <a
                            [routerLink]="link.routerLink | languagePrefix | async"
                            (click)="setRole(navItem.filter)"
                            >{{ link.title }}</a
                          >
                        </li>
                      }
                    }
                  </ul>
                }
              }
            </div>
          }
        </nav>

        <div id="footer-info">
          <div id="footer-logo">
            <img src="d4c-logo-monocolor.webp" alt="D4C logo" />
            <p>{{ data.translates['footer-organisation-note'] }}</p>
          </div>

          <div id="footer-contact">
            <h3>{{ data.translates['contact-information'] }}</h3>
            <p><a href="mailto:{{ data.settings.contact.email }}">{{ data.settings.contact.email }}</a></p>
            <p>{{ data.settings.contact.phone }}</p>

            <h3>{{ data.translates['address-information'] }}</h3>
            <p [innerHTML]="data.translates.address"></p>
          </div>
        </div>

        <div id="baseline">
          <span>{{ data.settings.poweredBy }}</span>

          <a id="cigaragency" href="https://cigar.agency" target="_blank"><img src="fired-up-by-ca.svg" alt="Fired up by CIGAR.AGENCY"
          /></a>

          <div id="socials">
            <!-- linkedin -->
             @if (data.settings.socials.linkedin){
            <a [href]="data.settings.socials.linkedin" target="_blank"><img src="linkedin.svg" alt="LinkedIn logo"
            /></a>}

            <!-- facebook -->
             @if (data.settings.socials.facebook){
            <a [href]="data.settings.socials.facebook" target="_blank"><img src="facebook.svg" alt="Facebook logo"
            /></a>}

            <!-- instagram -->
             @if (data.settings.socials.instagram){
            <a [href]="data.settings.socials.instagram" target="_blank"><img src="instagram.svg" alt="Instagram logo"
            /></a>}

            <!-- x -->
             @if (data.settings.socials.x){
            <a [href]="data.settings.socials.x" target="_blank"><img src="x.svg" alt="X logo" /></a>
}
            <!-- youtube -->
             @if (data.settings.socials.youtube){
            <a [href]="data.settings.socials.youtube" target="_blank"><img src="youtube.svg" alt="YouTube logo"
            /></a>}
          </div>
        </div>
      }
    </div>
  `,
  standalone: true
})
export class FooterComponent {
  store = inject(Store<{ general: GeneralState }>);
  data$ = this.store.select(Selectors.selectFooterData);

  setRole(role: UserRole) {
    this.store.dispatch(D4CActions.SetRole({ role }));
  }
}
